import { RefObject } from 'react';
import { dropdownOffset, StrategyEnum } from './dropdown.constants';
import type { CoordsType, StrategyType } from './dropdown.types';

export const updateCoords = (
    textBoxRef: RefObject<HTMLDivElement>,
    strategy: StrategyType,
    setCoords: (value: CoordsType) => void,
    inputErrorRef?: RefObject<HTMLDivElement> | null,
) => {
    const textBoxRect = textBoxRef?.current?.getBoundingClientRect();
    const inputErrorRect = inputErrorRef?.current?.getBoundingClientRect();

    if (strategy === StrategyEnum.PAGE) {
        const errorToTextFieldGap = dropdownOffset;
        const textFieldToDropdownGap = dropdownOffset;
        setCoords({
            top:
                (textBoxRect?.height ?? 0) +
                errorToTextFieldGap +
                (inputErrorRect?.height ?? 0) +
                textFieldToDropdownGap,
            left: 0,
            width: textBoxRect?.width ?? 0,
        });
    }

    if (strategy === StrategyEnum.MODAL) {
        setCoords({
            top: (textBoxRect?.top ?? 0) + (textBoxRect?.height ?? 0) + (inputErrorRect?.height ?? 0) + dropdownOffset,
            left: textBoxRect?.left ?? 0,
            width: textBoxRect?.width ?? 0,
        });
    }
};
